import { ItemGroup, TreeList } from '@ibsys/kit';
import { FolderIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { AttributeResponse } from '@/entities/attributes';
import { cn } from '@/shared/lib';
import { AttributeCard } from './AttributeCard';

const ICON_SIZE = 18;

type Props = {
  attributes: AttributeResponse[];
};

export const SimpleAttributesGroup: FC<Props> = ({ attributes }) => {
  const { t } = useTranslation('attributes');
  const { id, parentStruct: activeParentStructCode } = useParams<{ id?: string; parentStruct?: string }>();

  const isActive = (attribute: AttributeResponse) => {
    return attribute.code === id && (activeParentStructCode || 'SIMPLE') === attribute.parentStructCode;
  };

  return (
    <TreeList.Group
      value="SIMPLE"
      classNames={{
        content: 'p-3',
      }}
      label={
        <div className="flex flex-1 items-start gap-2">
          <div className={cn('mt-0.5 shrink-0', 'text-muted-foreground group-hover:text-foreground')}>
            <FolderIcon size={ICON_SIZE} />
          </div>
          <div className="flex-1 flex">
            <span className="line-clamp-2 text-left text-sm font-medium leading-tight">{t('simpleAttributes')}</span>
            {attributes.length !== undefined && (
              <span className="ml-2 text-xs text-muted-foreground">{`(${attributes.length})`}</span>
            )}
          </div>
        </div>
      }
    >
      <div className="flex flex-col gap-2">
        {attributes.length === 0 ? (
          <div className="text-sm text-muted-foreground py-2">{t('noAttributes')}</div>
        ) : (
          <ItemGroup className="flex flex-col gap-2">
            {attributes.map((attribute) => {
              return (
                <AttributeCard
                  key={`${attribute.code}.${attribute.parentStructCode}`}
                  attribute={attribute}
                  isActive={isActive(attribute)}
                />
              );
            })}
          </ItemGroup>
        )}
      </div>
    </TreeList.Group>
  );
};
